import React, {FC} from 'react';
import {ProductDetail, ProductSize} from "../types/types";
import {Button} from '../components/Button';
// import ShirtGuide from '../assets/img/shirt-guide.png';

interface CartPopUpProps {
    open: boolean;
    goCart: () => void;
    product: ProductDetail
    size: ProductSize
    onClose: () => void;
}

export const CartPopUp: FC<CartPopUpProps> = ({onClose, open, goCart, product, size}) => {
    if (!open) return <></>;
    return (
        <>
            <div data-aos="fade-in" data-aos-delay="900"
                className={`z-20 bg_3e52bb fixed md:right-4 md:top-18 md:w-3/12 top-18 flex p-4 space-x-4 w-11/12`}
            >
                <img
                    src={product.productImageUrls[0]}
                    alt=""
                    className="w-16 h-24"
                />

                <div className="text-white w-full">
                    <p className="text-14">
                        장바구니에 추가됨: <br/>
                        <span className="font-bold">
                            {product.productName}
                        </span>
                        <br/>
                        {product.productInfo.color}
                    </p>

                    <div className="flex justify-between">
                        <p className="">사이즈: {size.sizeName}</p>
                        <p className="">₩{product.currentPrice.toLocaleString()}</p>
                    </div>
                    <div className="flex mt-2">
                        <Button
                            text="계속 쇼핑하기"
                            className="w-full text-12 tx_3e52bb h-6 rounded-none bg-gray-100"
                            onClick={() => onClose()}
                        />
                        <Button
                            text="장바구니로 가기"
                            className="w-full ml-1 text-12 tx_3e52bb h-6 rounded-none bg-gray-100"
                            onClick={() => goCart()}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
